import { render } from "./AppMain.vue?vue&type=template&id=15af9a22&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=15af9a22&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=15af9a22&lang=scss"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15af9a22"]])

export default __exports__